import React from 'react';
import { Form, Input, Button, message, Select } from 'antd';
import InputRules from '../../../data/InputRules';

const layout = {
	labelCol: {
		span: 5,
	},
	wrapperCol: {
		span: 8,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 5,
		span: 16,
	},
};

const CityEditForm = ({ city, updateList, updateCity, setEditModal }) => {
	const onFinish = async (values) => {
		await updateCity(city._id, values);
		updateList();
		setEditModal();
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	return (
		<Form {...layout} name="city-edit-form" onFinish={onFinish} onFinishFailed={onFinishFailed}>
			<Form.Item
				label="Country"
				name="country"
				initialValue={city?.country}
				rules={InputRules.required('Please input country!')}
			>
				<Input />
			</Form.Item>
			<Form.Item
				label="Priority"
				name="priority"
				initialValue={city?.priority}
				rules={InputRules.number({ required: true, message: 'Please input priority', min: 0 })}
			>
				<Input />
			</Form.Item>
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Update City
				</Button>
			</Form.Item>
		</Form>
	);
};

export default CityEditForm;
